var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0457749 0.2144C0.0153749 0.2728 0.000175118 0.3364 0.000175118 0.4C0.000175118 0.48 0.0241748 0.5592 0.0713748 0.6276L3.67138 5.8276C3.74618 5.9356 3.86898 6 4.00018 6C4.13138 6 4.25418 5.9356 4.32898 5.8276L7.92898 0.6276C8.01338 0.5056 8.02338 0.346 7.95458 0.2144C7.88538 0.0824 7.74898 0 7.60018 0L0.400175 0C0.251375 0 0.114975 0.0824 0.0457749 0.2144Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleDown);
export default __webpack_public_path__ + "static/media/triangle-down.f031d59cb3466cda2ac2841420d394f9.svg";
export { ForwardRef as ReactComponent };